var stround = require('stround');

window.app = window.app || {};

window.app.pageArray = function (num, text) {
	var array = [];
	for (var i = 0; i < num; i++) {
		array.push({ id: i, name: text + (i + 1) });
	}
	return array;
};

window.app.pad = function (n, width, padChar) {
	if (width === null || typeof width === 'undefined') {
		return '';
	}

	if (n === null || typeof n === 'undefined') {
		n = '';
	}

	padChar = padChar || '0';
	n = n + '';
	return n.length >= width ? n : new Array(width - n.length + 1).join(padChar) + n;
};

//
// *
// * define a helper rounding function
// *
// * mimics the c# Math.Round() function using the AwayFromZero option
//

window.emsRound = function (strnum, precision) {
	if (precision === null || precision === undefined) {
		precision = 2;
	}
	if (isNaN(strnum + '')) return 0;

	strnum = parseFloat(strnum).toFixed(precision + 2); // just a little hack to handle numbers like 7.566995918750763e-10 and avoid error "cannot round malformed number"
	return Number(stround.round(strnum, precision, stround.modes.HALF_UP));
};

window.isPostalCodeValid = function (countryCode, postalCode) {
	countryCode = countryCode || '';
	postalCode = postalCode || '';
	var pattern;
	switch (countryCode.toUpperCase()) {
		case 'US':
			pattern = new RegExp('^\\d{5}(-\\d{4})?$');
			break;

		case 'CA':
			pattern = new RegExp('^[ABCEGHJKLMNPRSTVXY]{1}\\d{1}[A-Z]{1} *\\d{1}[A-Z]{1}\\d{1}$');
			break;
	}

	if (pattern) {
		return pattern.test(postalCode);
	}

	return true;
};

window.getServiceYearsAndMonths = function (startDate, endDate) {
	// If Start Date on or before the 15th - count the month
	// If Start Date after the 15th - do not count the month
	// If end date on or after 15th - count the month
	// If end date before 15th - Do not count the month
	if (!moment.isDate(startDate)) return { years: 0, months: 0 };

	if (!moment.isDate(endDate)) endDate = new Date();

	var startMoment = moment(startDate);
	var endMoment = moment(endDate);

	if (startMoment.isAfter(endMoment)) return { years: 0, months: 0 };
	// if less than 15 days worked then no credit for service
	if (endMoment.diff(startMoment, 'days') < 15) return { years: 0, months: 0 };
	// if start date is after the 15th then advance start date by one month
	if (startMoment.date() > 15) startMoment.add(1, 'months');
	// if end date is prior to the 15th then reduce end date by one month
	if (endMoment.date() <= 15) endMoment.add(-1, 'months');
	// after the adjustments above, ensure start date is not later than end date, if it is then make equal
	if (startMoment.isAfter(endMoment)) startmoment = endMoment;

	var years = endMoment.year() - startMoment.year();
	var months = 1 + endMoment.month() - startMoment.month();
	if (months === 12) {
		months = 0;
		years++;
	}
	if (months < 0) {
		months = 12 + months;
		years--;
	}
	return { years: years, months: months };
};

/*
 * calculateRoundedTax will calculate a tax value and return the value rounded to the hundreds decimal place.
 * When rounding the calculated value, rounding will only look as far as the 1000th decimal place to determine whether
 * to round up or not.  Any numbers after are ignored.
 * Example: Calculated Value 12.3449 will be rounded as 12.34
 * Example: Calculated Value 12.345 will be rounded as 12.35
 */
window.calculateRoundedTax = function (amount, taxRate) {
	if (isNaN(amount + '') || isNaN(taxRate + '')) return 0;

	const calculatedValue = amount * (taxRate / 100) * 100;
	const toFixedValue = calculatedValue.toFixed(3);
	const roundedValue = toFixedValue < 0 ? Math.round(toFixedValue * -1) * -1 : Math.round(toFixedValue);

	return roundedValue / 100;
};

/*
 * toShortDateFormat will format an ISO date compliant string into MM/DD/YYYY
 * this is an alternative rather than using moment which is depricated.
 */
window.toShortDateFormat = function (isoDateString) {
	try {
		const myDate = new Date(isoDateString);
		return new Intl.DateTimeFormat('en-US', { year: 'numeric', month: '2-digit', day: '2-digit' }).format(myDate);
	} catch {
		return '';
	}
};
